import Api from '@/services/Api'
import LocalStorage from '@/services/LocalStorageService'

const rootWorkFlow = 'workflows'
const rootClasses = 'classes'
const clientRoot = () => `${LocalStorage.getClientPrefix()}/workflows`

class WorkflowService {
  about () {
    return Api().get(`${clientRoot()}/about`)
  }

  findAllActions () {
    return Api().get(`${rootClasses}/getActions`)
  }

  findActionByDescription (description) {
    const params = { description }
    return Api().get(`${rootClasses}/getActions/description`, { params })
  }

  findByActionClassname (classname) {
    const params = { classname }
    return Api().get(`${rootClasses}/getActions/classname`, { params })
  }

  create (workflow) {
    return Api().post(rootWorkFlow, workflow)
  }

  update (workflow) {
    return Api().put(rootWorkFlow, workflow)
  }

  findAll () {
    return Api().get(clientRoot())
  }

  findByName (workflowName) {
    return Api().get(`${clientRoot()}/${workflowName}`)
  }

  delete (workflowName) {
    return Api().delete(`${clientRoot()}/${workflowName}`)
  }

  play (workflowName, body) {
    return Api().post(`${clientRoot()}/play/${workflowName}`, body)
  }
}

export default new WorkflowService()
